module.exports = __webpack_public_path__ + "img/logo-text.be67ff33.png";